var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddschool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(319 -4798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1590",
    "data-name": "Rectangle 1590",
    width: 23,
    height: 23,
    transform: "translate(-319 4798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495",
    transform: "translate(-51.161 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M8.765,16.845H.422A.4.4,0,0,1,0,16.424v-.843a.4.4,0,0,1,.422-.421H.845V5.9a.8.8,0,0,1,.844-.843V4.211a.8.8,0,0,1,.845-.843H4.221L8.442,0l3.8,3.369h2.11a.8.8,0,0,1,.845.843v.842a.8.8,0,0,1,.844.843V8.572a6.406,6.406,0,0,0-1.271-.127c-.139,0-.279,0-.417.013V6.737H11.819V9.168A6.382,6.382,0,0,0,9.465,11.3a1.687,1.687,0,0,0-2.712,1.338V15.16H8.431a6.3,6.3,0,0,0,.334,1.683Zm-6.232-5.9v2.527H5.065V10.949Zm4.22-4.211V9.264h3.378V6.737Zm-4.22,0V9.264H5.065V6.737ZM8.189,1.684a.8.8,0,0,0-.845.843.845.845,0,0,0,.845.842.8.8,0,0,0,.844-.842A.8.8,0,0,0,8.189,1.684Z",
    transform: "translate(-265.839 4798)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(-255.304 4808.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 2.116,
    height: 8.444,
    transform: "translate(3.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 2.111,
    height: 8.464,
    transform: "translate(8.464 3.167) rotate(90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddschool);
export default __webpack_public_path__ + "static/media/addschool.e033008060dff56e6e73b349502a0d80.svg";
export { ForwardRef as ReactComponent };